/// <reference path="../actions/profileaction.js" />
/**
 * [Ref] - Denotes Pseudo Code Reference  
 *  
 * This component is the Replenish Review Component. The component displays the details of Item which user wants to change 
 * the qty that they want to be ready in warehouse .
 * 
 * App Name: WalmartWeb
 * Author: Aparna
 * Created Date: 8/4/20201
 */
import React, { Component } from 'react';
/**
 * Ref: RR_PC_02
 * Importing the action and store file and set to an object.
 */
import * as ReplenAction from '../actions/ReplenishReviewAction';
import ReplenStore from '../stores/ReplenishReviewStore';
import * as CookieService from '../CookieService';
import SDIConstants from '../SDIConstants';
import * as $ from 'jquery';
import ReactPaginate from 'react-paginate';
import { withTranslation, Trans } from 'react-i18next'
import * as MenuAction from '../actions/MenuAction';
import swal from 'sweetalert';
let currentPagePath;
let isSubmit = false;
let canInsert = true;
let Index = "";

class ReplenishReview extends Component {
    /**
    * Ref: RR_PC_01,
    * RR_PC_02
    * Define the constructor that takes props as parameter
    * 
    * @param props
    */


    constructor(props) {

        super(props);
        this.PageLoadResponse = this.PageLoadResponse.bind(this);
        this.filterClick = this.filterClick.bind(this);
        this.keyPress = this.keyPress.bind(this);
        this.handleSearchTxt = this.handleSearchTxt.bind(this);
        this.ForecastClick = this.ForecastClick.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.bindForecast = this.bindForecast.bind(this);
        this.bindBuGrid = this.bindBuGrid.bind(this);
        this.ClearSearch = this.ClearSearch.bind(this);
        this.clearItemId = this.clearItemId.bind(this);
        this.BUClick = this.BUClick.bind(this);
        this.BUResponse = this.BUResponse.bind(this);
        this.HistoryClick = this.HistoryClick.bind(this);
        this.HistoryResponse = this.HistoryResponse.bind(this);
        this.bindHistoryGrid = this.bindHistoryGrid.bind(this);
        this.bindMoreDetail = this.bindMoreDetail.bind(this);
        this.GetDataResponse = this.GetDataResponse.bind(this);
        this.ProcessReplenResponse = this.ProcessReplenResponse.bind(this);
        this.UpdateItemResponse = this.UpdateItemResponse.bind(this);
        this.MoreDetailClick = this.MoreDetailClick.bind(this);
        this.showReasonPopUp = this.showReasonPopUp.bind(this);
        this.UpdateItemClick = this.UpdateItemClick.bind(this);
        this.expandAll = this.expandAll.bind(this);
        /**
       * Ref: RR_PC_03
       * Set the initial values of the state variables
       */
        this.state = {
            PageLoadData: [],
            Site: [],
            Vendor: [],
            BUArr: [],
            BUData: [],
            VendorData: [],
            ItemData: [],
            ImgArr: [],
            isSearch: false,
            HistoryCheck: false,
            searchColumn: "ALL",
            filterDisplayName: "All",
            sortColumn: "item_no",
            isSearch: false,
            sortValue: "ASC",
            SelectSite: "",
            SelectVendor: "",
            SelectActionCode: "",
            SelectUtilCode: "",
            SelectForcastFam: "",
            SelectReplenType: "",
            SelectReplenClass: "",
            SelectBU: "0",
            SelectReplenStatus: "",
            SelectInventoryType: "",
            GridData: [],
            BckGridData: [],
            txtItemID: "",
            searchTxt: "",
            ZeroOnHandCheck: false,
            NotOnOrderCheck: false,
            PageNo: 1,
            totalCount: 0,
            RecCount: 10,
            PageCount: 0,
            isExpand: false,
            YearMonth: [],

            isFavorited: false,
            selectedOption: "",
            reasonError: true,
            customE: null,
            customVal: null,
            customIndex: null,
            Reasons: [],
            oldValues: [],/*WW-798,created some state variable to store the reason for selecting replen off, Divis Kumar R K*/
        }
    };
    /**
   * Ref: RR_PC_04
   * componentwillMount method will be first method which will be invoked
   * 
   */
    componentDidMount() {



        $("#forecastpopup").hide();
        $("#bupopup").hide();
        $("#historypopup").hide();
        $("#moredetailpopup").hide();

        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        let BO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP")
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ReplenAction.ReplenPageLoad(BO)
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        ReplenAction.getCurrentFavPage(getFavPageBO);
        ReplenStore.on('PageLoad', this.PageLoadResponse.bind(this));
        ReplenStore.on('popupData', this.BUResponse.bind(this));
        ReplenStore.on('popupData', this.HistoryResponse.bind(this));
        ReplenStore.on('Vendor', this.OnSelectSiteResponse.bind(this));
        ReplenStore.on('GetData', this.GetDataResponse.bind(this));
        ReplenStore.on('ProcessReplen', this.ProcessReplenResponse.bind(this));
        ReplenStore.on('UpdateItem', this.UpdateItemResponse.bind(this));
        ReplenStore.on('OnStatusChange', this.OnStatusChangeResponse.bind(this));
        ReplenStore.on('favpage', this.loadFavPageResponse.bind(this));
        ReplenStore.on('updateFavPage', this.updateFavPageResponse.bind(this));

    }
    componentWillUnmount() {
        ReplenStore.removeListener('PageLoad', this.PageLoadResponse);
        ReplenStore.removeListener('popupData', this.BUResponse);
        ReplenStore.removeListener('popupData', this.HistoryResponse);
        ReplenStore.removeListener('Vendor', this.OnSelectSiteResponse);
        ReplenStore.removeListener('GetData', this.GetDataResponse);
        ReplenStore.removeListener('ProcessReplen', this.ProcessReplenResponse);
        ReplenStore.removeListener('UpdateItem', this.UpdateItemResponse);
        ReplenStore.removeListener('OnStatusChange', this.OnStatusChangeResponse);
        ReplenStore.removeListener('favpage', this.loadFavPageResponse);
        ReplenStore.removeListener('updateFavPage', this.updateFavPageResponse);
    }
    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(ReplenStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    }
    updateFavPageResponse = () => {
        if (ReplenStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(ReplenStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(ReplenStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        // this.refreshMenu();
    }

    //CPW-97 Replenish review _Yuvarani K


    BUClick = (e, value, index) => {

        
        Index = index;
        e.preventDefault();
        $('#bupopup').modal('show');


        let item_no = value.item_no
        let BUBO = {
            item_no: item_no,
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_ISA_CRIB_IDENT: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT")
        }
        ReplenAction.GetOtherData(BUBO)
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
    }

    //CPW-97 Replenish review _Yuvarani K
    handleCloseClick = (index) => {
        let GridData = [...this.state.GridData];
        GridData[index] = Object.keys(GridData[index]).reduce((acc, key) => {
            acc[key] = '';
            return acc;
        }, {});
        this.setState({ GridData });
        console.log("handleCloseClick", GridData);
    };





    //CPW-97 Replenish review _Yuvarani K
    BUResponse = () => {

        
        let GetDataResponse = JSON.parse(ReplenStore.GetData);
        let data = GetDataResponse.BUDetail;

        this.setState({ BUData: data });
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

    }

    HistoryClick = (e, value, index) => {
        e.preventDefault();
        $('#historypopup').modal('show');

        let item_no = value.item_no
        let HistoryBO = {
            item_no: item_no,
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_ISA_CRIB_IDENT: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT")
        }
        ReplenAction.GetOtherData(HistoryBO)
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
    }



    HistoryResponse = () => {

        
        let GetDataResponse = JSON.parse(ReplenStore.GetData);
        let ItemData = GetDataResponse.ItemDetail;
        let VendorData = GetDataResponse.VendorDetail;

        this.setState({ VendorData: VendorData, ItemData: ItemData });
        $(`#${SDIConstants.SDILoader}`).addClass('hide');

    }

    ClearSearch = () => {


        document.getElementById("searchTxt").value = "";
        this.setState({ searchTxt: "", isSearch: false });
        let searchValue = document.getElementById("searchTxt").value;
        let pageNo = 1;

        //5759 - Blank page is displaying 5/13/2025 Nachiappan
        this.GetDataClick(pageNo, true,
            this.state.sortValue,
            this.state.searchColumn,
            this.state.sortColumn,
            searchValue,
        );

        this.setState({ PageNo: pageNo })
    }

    clearItemId = () => {
        document.getElementById("itemID").value = "";
        this.setState({ txtItemID: "" });
    }
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Replenish Review",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            ReplenAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            ReplenAction.deleteFavPage(deleteFavPageBO)
        }
    };






    /**
     * RR_PC_06
     */
    PageLoadResponse = () => {
        
        let PageLoad = JSON.parse(ReplenStore.PageLoadData);
        console.log("DataResponse", PageLoad)
        this.setState({ Site: PageLoad.SiteTable, BUArr: PageLoad.BUTable, Reasons: PageLoad.ReasonTable });
        console.error("Reasons", this.state.Reasons)
    }
    /**
     * RR_PC_08
     */

    OnSelectSiteResponse = () => {
        let OnSelectSiteResponse = JSON.parse(ReplenStore.PageLoadData);
        console.log("OnSelectSiteResponse", OnSelectSiteResponse)
        this.setState({ Vendor: OnSelectSiteResponse.SDI_VENDORS });
    }
    /***
     * RR_PC_07
     * */
    GetDataResponse = () => {
        

        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let GetDataResponse = JSON.parse(ReplenStore.GetData);
        let data = GetDataResponse.DATA
        this.setState({ oldValues: data });/*WW-798,to store the old class value, Divis Kumar R K*/
        let yearmonth = GetDataResponse.Yearmonth
        let ImageTable = GetDataResponse.ImgTable
        console.log("yearmonth", yearmonth)


        //for pagination 
        let count = 0

        if (GetDataResponse.DATA != [] && GetDataResponse.DATA != undefined) {
            count = GetDataResponse.DATA.length
        }

        let pg = Math.ceil((count > 0 ? count : 0) / this.state.RecCount);


        $('.header-arrow').addClass('accordion-arrow-change');
        $('.content-row').removeClass('d-none');
        $('.header-arrow').removeClass('accordion-arrow-change');
        $('.content-row').addClass('d-none');


        this.setState({ GridData: GetDataResponse.SDI_IMS_DATA, BckGridData: GetDataResponse.SDI_IMS_DATA, isExpand: false, totalCount: count, pageCount: pg, PageNo: this.state.PageNo, YearMonth: yearmonth, ImgArr: ImageTable });
        //WW-582- Replenishment Review screen can get data but when I request EXPORT to EXCEL all-Deepthi N H
        if (GetDataResponse.SDI_IMS_DATA != undefined) {
            if (GetDataResponse.SDI_IMS_DATA.length == 0) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "No record found"
                });
                this.setState({ searchTxt: "" });
                document.getElementById("searchTxt").value = "";

                // alert("No record found");
                return;
            }

        }


    }

    handlePageClick = (data) => {

        let pageNo = data.selected + 1;

        this.GetDataClick(pageNo, false);
        this.setState({ PageNo: pageNo, isExpand: false });




        //;
        // isPostBack = false;
    };


    //CPW-97 Replenish review _Yuvarani K
    bindMoreDetail = (Index) => {
        if (this.state.GridData.length > 0) {
            return this.state.GridData.map((value, index) => {
                if (Index == index) {

                    return (<>
                        <div className="modal-body px-4">
                            <div className="row">
                                {/*labels*/}
                                <div className="col-md-6 mb-3">
                                    <label className="font-14 font-medium w-100 mb-2 color-dark-black">
                                        Utilization code
                                 </label>

                                    <label className="font-14 font-regulars w-100 mb-0 color-light-black">{value.inv_class != "" && value.inv_class != null && value.inv_class != undefined ? value.inv_class : "-"}</label>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="font-14 font-medium w-100 mb-2 color-dark-black">
                                        Next review
              </label>


                                    <label className="font-14 font-regulars w-100 mb-0 color-light-black">{value.next_review_dt != "" && value.next_review_dt != null && value.next_review_dt != undefined ? value.next_review_dt : "-"}</label>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="font-14 font-medium w-100 mb-2 color-dark-black">
                                        Date postponed
              </label>
                                    <label className="font-14 font-regulars w-100 mb-0 color-light-black">{value.postponed_dt != "" && value.postponed_dt != null && value.postponed_dt != undefined ? value.postponed_dt : "-"}</label>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="font-14 font-medium w-100 mb-2 color-dark-black">
                                        Max capacity
              </label>
                                    <label className="font-14 font-regulars w-100 mb-0 color-light-black">{value.max_cap != "" && value.max_cap != null && value.max_cap != undefined ? value.max_cap : "-"}</label>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="font-14 font-medium w-100 mb-2 color-dark-black">
                                        Client stock type
              </label>
                                    <label className="font-14 font-regulars w-100 mb-0 color-light-black">{value.sap_stk_type != "" && value.sap_stk_type != null && value.masap_stk_typex_cap != undefined ? value.sap_stk_type : "-"}</label>
                                </div>
                            </div>
                        </div>
                    </>
                    );
                }
            });
        }
    }




    /***
     * RR_PC_12
     * */
    ProcessReplenResponse = () => {
        let GetDataResponse = JSON.parse(ReplenStore.GetData);
        console.log("GridDataReplen", GetDataResponse)
        if (GetDataResponse.ErrorMessage.length > 0) {
            if (GetDataResponse.ErrorMessage[0].lblerror != undefined && GetDataResponse.ErrorMessage[0].lblerror != null && GetDataResponse.ErrorMessage[0].lblerror != "" && GetDataResponse.ErrorMessage[0].lblerror != " ") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: GetDataResponse.ErrorMessage[0].lblerror
                });
                //  alert(GetDataResponse.ErrorMessage[0].lblerror);
                return
            } else {
                if (GetDataResponse.SDI_IMS_DATA != undefined) {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Inserted successfully"
                    });
                    // alert("Inserted successfully");
                    this.GetDataClick(this.state.PageNo, false)//WBW-8_PC_01 (2/17/2022)-Aparna
                    return
                }
                else {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: "Insertion failed"
                    });
                    // alert("Insertion failed");
                    return
                }
            }
        }
        else {
            if (GetDataResponse.SDI_IMS_DATA != undefined) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Inserted successfully"
                });
                ///  alert("Inserted successfully");
                this.GetDataClick(this.state.PageNo, false)//WBW-8_PC_01 (2/17/2022)-Aparna
                return
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Insertion failed"
                });
                //   alert("Insertion failed");
                return
            }
        }
        //this.setState({ GridData: GetDataResponse.SDI_IMS_DATA });
    }
    /**
     * RR_PC_11
     * */
    UpdateItemResponse = () => {
        let GetDataResponse = JSON.parse(ReplenStore.GetData);
        console.log("GridDataReplen", GetDataResponse.FlagTable[0].msg);
        //WW-496_PC_02 (9/219/2022)-Aparna
        if (GetDataResponse.FlagTable[0].msg) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Updated successfully"
            });
        }

        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Updated failed"
            });
        }
        { this.hidePopUp() }




        this.GetDataClick(this.state.PageNo, false)
        $('#forecastpopup').modal('hide');
    }
    /**
     *RR_PC_15
     */
    BindBU = () => {
        return this.state.BUArr.map((value, ID) => {
            if (value.replen_bu != "") {
                return (
                    <option value={value.replen_bu}>{value.replen_bu}</option>
                )
            }


        });
    }

    /**
 *RR_PC_16
 */
    Bindsite = () => {
        return this.state.Site.map((value, ID) => {
            if (value.loc_no != "") {
                return (
                    <option value={value.loc_no}>{value.site}</option>
                )
            }


        });
    }

    //CPW-97 Replenish review _Yuvarani K

    bindForecast = (Index) => {
        if (this.state.GridData.length > 0) {
            return this.state.GridData.map((value, index) => {
                if (Index == index) {
                    return (<>
                        {/*Body Starts here*/}
                        <div className="modal-body px-4">
                            {/*grid starts here*/}
                            <div className="table-responsive mt-2">
                                <table className="table split-delv-table mb-0">
                                    <thead className="sticky-top">
                                        <tr>
                                            <th />
                                            <th>{this.state.YearMonth[0].y0}</th>
                                            <th>{this.state.YearMonth[0].y1}</th>
                                            <th>{this.state.YearMonth[0].y2}</th>
                                            <th>Forecast</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        <tr>
                                            <td>{this.state.YearMonth[0].m1}</td>
                                            <td>{value.y0m1 != null && value.y0m1 != undefined && value.y0m1 != "" ? value.y0m1 : "-"}</td>
                                            <td>{value.y1m1 != null && value.y1m1 != undefined && value.y1m1 != "" ? value.y1m1 : "-"}</td>
                                            <td>{value.y2m1 != null && value.y2m1 != undefined && value.y2m1 != "" ? value.y2m1 : "-"}</td>
                                            <td><input maxLength="9" type="text" id="fm1" value={value.fm1} className="form-control" name="fm1" onChange={(e) => this.handleGridChange(e, value, index)} /></td>
                                            <label className="catalog-label mt-2 mb-0 d-none" value={value.fm1} id={`fm1-${index}`}><Trans>Replenish Type</Trans></label>
                                        </tr>
                                        <tr>
                                            <td>{this.state.YearMonth[0].m2}</td>
                                            <td>{value.y0m2 != null && value.y0m2 != undefined && value.y0m2 != "" ? value.y0m2 : "-"}</td>
                                            <td>{value.y1m2 != null && value.y1m2 != undefined && value.y1m2 != "" ? value.y1m2 : "-"}</td>
                                            <td>{value.y2m2 != null && value.y2m2 != undefined && value.y2m2 != "" ? value.y2m2 : "-"}</td>
                                            <td><input maxLength="9" type="text" id="fm2" value={value.fm2} className="form-control" name="fm2" onChange={(e) => this.handleGridChange(e, value, index)} /></td>
                                            <label className="catalog-label mt-2 mb-0 d-none" value={value.fm2} id={`fm2-${index}`}><Trans>Replenish Type</Trans></label>
                                        </tr>
                                        <tr>
                                            <td>{this.state.YearMonth[0].m3}</td>
                                            <td>{value.y0m3 != null && value.y0m3 != undefined && value.y0m3 != "" ? value.y0m3 : "-"}</td>
                                            <td> {value.y1m3 != null && value.y1m3 != undefined && value.y1m3 != "" ? value.y1m3 : "-"}</td>
                                            <td>{value.y2m3 != null && value.y2m3 != undefined && value.y2m3 != "" ? value.y23 : "-"}</td>
                                            <td><input maxLength="9" type="text" id="fm3" value={value.fm3} className="form-control" name="fm3" onChange={(e) => this.handleGridChange(e, value, index)} /></td>
                                            <label className="catalog-label mt-2 mb-0 d-none" value={value.fm3} id={`fm3-${index}`}><Trans>Replenish Type</Trans></label>
                                        </tr>
                                        <tr>
                                            <td>{this.state.YearMonth[0].m4}</td>
                                            <td>{value.y0m4 != null && value.y0m4 != undefined && value.y0m4 != "" ? value.y0m4 : "-"}</td>
                                            <td>{value.y1m4 != null && value.y1m4 != undefined && value.y1m4 != "" ? value.y1m4 : "-"}</td>
                                            <td>{value.y2m4 != null && value.y2m4 != undefined && value.y2m4 != "" ? value.y2m4 : "-"}</td>
                                            <td><input maxLength="9" type="text" id="fm4" value={value.fm4} className="form-control" name="fm4" onChange={(e) => this.handleGridChange(e, value, index)} /></td>
                                            <label className="catalog-label mt-2 mb-0 d-none" value={value.fm4} id={`fm4-${index}`}><Trans>Replenish Type</Trans></label>
                                        </tr>
                                        <tr>
                                            <td>{this.state.YearMonth[0].m5}</td>
                                            <td>{value.y0m5 != null && value.y0m5 != undefined && value.y0m5 != "" ? value.y0m5 : "-"}</td>
                                            <td>{value.y1m5 != null && value.y1m5 != undefined && value.y1m5 != "" ? value.y1m5 : "-"}</td>
                                            <td>{value.y2m5 != null && value.y2m5 != undefined && value.y2m5 != "" ? value.y2m5 : "-"}</td>
                                            <td><input maxLength="9" type="text" id="fm5" value={value.fm5} className="form-control" name="fm5" onChange={(e) => this.handleGridChange(e, value, index)} /></td>
                                            <label className="catalog-label mt-2 mb-0 d-none" value={value.fm5} id={`fm5-${index}`}><Trans>Replenish Type</Trans></label>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>



                        {/*button*/}
                        <div className="modal-footer border-0 px-4">
                            <button className="btn btn-dark-grey font-14 font-medium mr-3 px-4"
                                type="button"
                                data-dismiss="modal" onClick={() => this.closeForecastPopup(index)}>Cancel</button>

                            <button
                                className="btn btn-custom-primary font-14 font-medium px-4" onClick={(e) => this.UpdateItemClick(e, value, index, "forecast")}
                                type="button">Save</button>


                        </div>
                        {/*button*/}

                    </>);
                }


            });
        }

    }



    //CPW-97 Replenish review _Yuvarani K
    bindBuGrid = () => {
        
        if (this.state.BUData.length > 0) {

            return this.state.BUData.map((value, index) => {
                return (<>
                    <tr className="border-bottom">
                        <td>{value.REPLEN_BU != null && value.REPLEN_BU != undefined && value.REPLEN_BU != "" ? value.REPLEN_BU : "-"}</td>
                        <td>{value.BU_DESCRIPTION != null && value.BU_DESCRIPTION != undefined && value.BU_DESCRIPTION != "" ? value.BU_DESCRIPTION : "-"}</td>
                        <td >{value.QTY_AVAILABLE != null && value.QTY_AVAILABLE != undefined && value.QTY_AVAILABLE != "" ? value.QTY_AVAILABLE : "-"}</td>
                        <td>{value.MIN != null && value.MIN != undefined && value.MIN != "" ? value.MIN : "-"}</td>
                        <td>{value.MAX != null && value.MAX != undefined && value.MAX != "" ? value.MAX : "-"}</td>
                        <td>{value.REPLEN_CLASS != null && value.REPLEN_CLASS != undefined && value.REPLEN_CLASS != "" ? value.REPLEN_CLASS : "-"}</td>
                        <td>{value.REPLEN_OFF != null && value.REPLEN_OFF != undefined && value.REPLEN_OFF != "" ? value.REPLEN_OFF : "-"}</td>
                    </tr>
                </>);
            });
        }
        else {
            return (<>


                <tr>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                </tr>
            </>);
        }
    }



    /**
     *RR_PC_17
     */


    //CPW-97 Replenish review _Yuvarani K
    bindHistoryGrid = (name) => {


        
        if (name == "ItemDetails") {

            if (this.state.HistoryCheck) {
                this.setState({ HistoryCheck: false })
            }


            if (this.state.ItemData.length > 0) {
                return this.state.ItemData.map((value, index) => {
                    return (<>

                        <tr className="border-bottom">

                            <td>{value.TRUNC_DT_TIMESTAMP != null && value.TRUNC_DT_TIMESTAMP != undefined && value.TRUNC_DT_TIMESTAMP != "" ? value.TRUNC_DT_TIMESTAMP : "-"}</td>
                            <td>{value.MIN_VAL != null && value.MIN_VAL != undefined && value.MIN_VAL != "" ? value.MIN_VAL : "-"}</td>
                            <td>{value.MAX_VAL != null && value.MAX_VAL != undefined && value.MAX_VAL != "" ? value.MAX_VAL : "-"}</td>
                            <td>{value.REPLEN_TYPE != null && value.REPLEN_TYPE != undefined && value.REPLEN_TYPE != "" ? value.REPLEN_TYPE : "-"}</td>
                            <td>{value.ITEM_TYPE != null && value.ITEM_TYPE != undefined && value.ITEM_TYPE != "" ? value.ITEM_TYPE : "-"}</td>
                        </tr>

                    </>);
                });
            }
            else {
                return (<>
                    <tr className="border-bottom">
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                    </tr>
                </>);
            }

        }


        else if (name == "VendorDetails") {

            if (!this.state.HistoryCheck) {
                this.setState({ HistoryCheck: true })
            }


            // Return null if VendorData is empty
            if (this.state.VendorData.length > 0) {

                // Set HistoryCheck to true if VendorData has items


                return this.state.VendorData.map((value, index) => {
                    return (<>

                        <tr className="border-bottom">
                            <td>{value.NAME1 != null && value.NAME1 != undefined && value.NAME1 != "" ? value.NAME1 : "-"}</td>
                            <td>{value.EFFDT != null && value.EFFDT != undefined && value.EFFDT != "" ? value.EFFDT : "-"}</td>
                            <td>{value.PRICE_VNDR != null && value.PRICE_VNDR != undefined && value.PRICE_VNDR != "" ? value.PRICE_VNDR : "-"}</td>

                        </tr>


                    </>);
                });
            }
            else {
                return (<>
                    <tr className="border-bottom">
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>

                    </tr>
                </>);
            }

        }







    }





    vendorData = () => {
        return this.state.Vendor.map((value, ID) => {
            if (value.vendor.toUpperCase() != "CHOOSE A VENDOR" && value.vendor.toUpperCase() != "SELECT" && value.vendor != " ") {
                return (
                    <option value={value.vendor}>{value.vendor}</option>
                );
            }


        });
    }

    /**
    * RR_PC_11
    */
    handleSiteChange = (event) => {
        if (event.target.value != "0") {
            let BO = {
                ddlSite: event.target.value,
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP")
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            this.setState({ [event.target.name]: event.target.value, GridData: "", isExpand: false });
            ReplenAction.OnSiteSelectAction(BO)
        }

    }

    /**
     * RR_PC_12
     */

    handleChange = (event) => {
        let regex = SDIConstants.alphanumericRegex
        const value = event.target.value;
        if (regex.test(value) || value === "") {
            this.setState({ [event.target.name]: value });
            this.setState({ searchTxt: "", isSearch: false, GridData: [], totalCount: 0 })
        }
    }

    /**
     * RR_PC_14
     */
    GetDataClick = (current, isGetdataClick, filterDisplayName, searchColumn, sortColumn, searchTxt, sortValue) => {
        if (this.state.SelectSite != "") {
            if (searchColumn === "") {
                searchColumn = "ALL";
            }
            let BO = {
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                ddlSite: this.state.SelectSite,
                RequestItemNo: this.state.txtItemID,
                ddlVendors: this.state.SelectVendor,
                ddlUtil: this.state.SelectUtilCode,
                ddlActionCode: this.state.SelectActionCode,
                chkZeroOnHand: this.state.ZeroOnHandCheck,
                chkOnPO: this.state.NotOnOrderCheck,
                sortColumn: sortColumn,
                sortValue: sortValue,
                searchColumn: searchColumn,
                searchTxt: searchTxt,
                txtItemID: this.state.txtItemID,
                ddlFamily: this.state.SelectForcastFam,
                ddlItemType: this.state.SelectReplenType,
                ddlReplenType: this.state.SelectReplenClass,
                ddlReview: this.state.SelectReplenStatus,
                ddlBu: this.state.SelectBU,
                CurrentPage: current,
                NeededRecCount: "10",
                InventoryType: this.state.SelectInventoryType,
                Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH")
            }
            let GetDataClickBO = this.state.GetDataClickBO
            if (GetDataClickBO != null && GetDataClickBO != undefined && GetDataClickBO != "" && GetDataClickBO != " ") {
                GetDataClickBO.CurrentPage = current
            }

            if (isGetdataClick) {
                this.setState({ GetDataClickBO: BO })
            } else {
                if (JSON.stringify(BO) != JSON.stringify(GetDataClickBO)) {
                    BO = this.state.GetDataClickBO
                }
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            ReplenAction.GetDataAction(BO)
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please select site"
            });
            // alert("Please select site")
            return;
        }
        //5759 - filterdisplaysearch is removed from updation [4/25/2025] Nachiappan
        this.setState({ PageNo: current , searchColumn: searchColumn })
    };
    /**
    *RR_PC_23
    * */
    CancelClick = () => {

        this.setState({
            SelectSite: "", SelectActionCode: "", SelectUtilCode: "", SelectBU: "0", SelectForcastFam: "",
            SelectReplenClass: "", SelectReplenStatus: "", SelectReplenType: "", SelectVendor: "", Vendor: [], ZeroOnHandCheck: false, NotOnOrderCheck: false, txtItemID: "",
            SelectInventoryType: "", GridData: []
        });
    }

    /**
     * RR_PC_19
     * */
    filterClick = (event, displayName, columnName) => {
        event.preventDefault();
        this.setState({ filterDisplayName: displayName, searchColumn: columnName });
    }

    handleSearchTxt = (e) => {
        let val = e.target.value;
        this.setState({ searchTxt: val })
    }


    handleSearch = () => {

        let pageNo = 1;
        //let value = $(`#searchTxt`).val().trim();
        // searchTxt = searchTxt.replaceAll("'","''")
        if (this.state.searchTxt !== '') {
            this.GetDataClick(pageNo, true,
                this.state.sortValue,
                this.state.searchColumn,
                this.state.sortColumn,
                this.state.searchTxt,
            );
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Enter the value"
            });
        }




        this.setState({ PageNo: pageNo, isSearch: true });
    };



    keyPress = (e) => {
        if (e.keyCode == 13) {
            { this.handleSearch() };
        }
    }



    sortingClick = (sortColumn, sortValue) => {
        let searchText = ""
        console.log(sortColumn, sortValue);
        if (this.state.isSearch) {
            searchText = $(`#searchTxt`).val().trim();
        }
        else {
            searchText = "";
        }

        this.setState({ searchTxt: searchText })
        let pageNo = this.state.PageNo;
        this.GetDataClick(pageNo, true,
            sortColumn,
            this.state.searchTxt,
            sortValue,
            this.state.searchColumn,
        );
        this.setState({ PageNo: pageNo, sortColumn: sortColumn, sortValue: sortValue, isSearch: false });
    }

    /**
   * 24/8/2021
   * WW-219(for inventory type dropdown)
   * "SelectInventoryType" added
   * */

    /**
     * RR_PC_19
     * */
    ExportToExcelClick = () => {
        let BO = {
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
            ddlSite: this.state.SelectSite,
            sortColumn: this.state.sortColumn,
            sortValue: this.state.sortValue,
            RequestItemNo: this.state.txtItemID,
            ddlVendors: this.state.SelectVendor,
            ddlUtil: this.state.SelectUtilCode,
            ddlActionCode: this.state.SelectActionCode,
            chkZeroOnHand: this.state.ZeroOnHandCheck,
            chkOnPO: this.state.NotOnOrderCheck,
            txtItemID: this.state.txtItemID,
            ddlFamily: this.state.SelectForcastFam,
            ddlItemType: this.state.SelectReplenType,
            ddlReplenType: this.state.SelectReplenClass,
            ddlReview: this.state.SelectReplenStatus,
            ddlBu: this.state.SelectBU,
            CurrentPage: 1,
            NeededRecCount: "10",
            InventoryType: this.state.SelectInventoryType,
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ReplenAction.ExportToExcelAction(BO)
    };





    /**
     * RR_PC_18
     * */

    handleGridChange = (e, value, index) => {
        let label = e.target.name
        const re = SDIConstants.quantityRegEX;
        //[12/5/22, Bug - 2960 - To change the selected value for the replenish type, Dhevanesam R]
        if (e.target.value === '' || re.test(e.target.value) || (e.target.name == "replen_class" || e.target.name == "replen_type") || (e.target.name == "item_type")) {
            //let { GridData } = this.state;
            let GridData = [...this.state.GridData];
            GridData[index] = { ...GridData[index], [e.target.name]: e.target.value };
            this.setState({ GridData });
            console.log("handleGridChange", GridData)
        }
        else {
            let GridData = [...this.state.GridData];
            GridData[index] = { ...GridData[index], [e.target.name]: e.target.value.substring(0, e.target.value.length - 1) };
            this.setState({ GridData });
            console.log("handleGridChange", GridData)
        }
    };

    //GridData[index].`${label}` = e.target.value
    //this.setState({ ...this.state.GridData[index], [e.target.name]: [e.target.value] });


    /**
     * RR_PC_20
     * */
    ProcessReplenClick = () => {
        let BO = {
            ddlSite: this.state.SelectSite,
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            CurrentPage: 1,
            NeededRecCount: 10,
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ReplenAction.ProcessReplenClick(BO)
    };

    /**
     * RR_PC_13
     * */
    UpdateItemClick = (e, val, index, type) => {


        this.setState({ customE: e, customVal: val, customIndex: index })

        if (type == "line_item") {
            let Min = val.min;
            let Max = val.max
            if (Min == "") {
                Min = 0;
            }
            if (Max == "") {
                Max = 0;
            }
            if (parseInt(Min) > parseInt(Max)) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Minimum value should not be greater than maximum value"
                });
            }

            else if (this.state.oldValues[index].replen_type != val.replen_type && isSubmit == false && val.replen_type == "X") {
                this.showReasonPopUp();

            }
            if (canInsert == true && parseInt(Min) <= parseInt(Max)) {
                
                let BO = {
                    Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                    Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                    Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                    ddlAct: val.replen_action,
                    TxtReplenOrderQty1: val.replen_qty,
                    std_cost: val.std_cost,
                    TxtReplenExtCost: "",
                    txtItemID: this.state.txtItemID,
                    ddlFamily: "",
                    ddlItemType: "",
                    ddlReplenType: "",
                    ddlReview: "",
                    ddlBu: val.replen_bu,
                    fm1: val.fm1,
                    fm2: val.fm2,
                    fm3: val.fm3,
                    fm4: val.fm4,
                    fm5: val.fm5,
                    fm6: val.fm6,
                    fm7: val.fm7,
                    fm8: val.fm8,
                    fm9: val.fm9,
                    fm10: val.fm10,
                    fm11: val.fm11,
                    fm12: val.fm12,
                    Package_Size: val.inc_orq,
                    LblMaxCap: val.max_cap,
                    Service_Level: val.service_level,
                    Safety_Stock: val.calc_ss,
                    ddlRplCls: val.replen_type,
                    ddlRplClsOld: this.state.oldValues[index].replen_type,
                    ddlRplTyp: val.item_type,
                    ddlRplTypOld: "",
                    txtOOQ: val.adj_orq,
                    txtMin: val.min,
                    hdnMin: "",
                    txtMax: val.max,
                    hdnMax: "",
                    hdnLocNo: val.loc_no,
                    hdnItemNo: val.item_no,
                    Replen_BU: val.replen_bu,
                    ReplenOffReason: this.state.selectedOption/*WW-798, changed and added values in BO, Divis Kumar R K*/
                }
                $(`#${SDIConstants.SDILoader}`).removeClass('hide');
                ReplenAction.UpdateItemAction(BO);
                isSubmit = false;
                this.setState({ selectedOption: "" })
            }
        }

        else if (type == "forecast") {
            
            let BO = {
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                ddlAct: val.replen_action,
                TxtReplenOrderQty1: "",
                std_cost: "",
                TxtReplenExtCost: "",
                txtItemID: "",
                ddlFamily: "",
                ddlItemType: "",
                ddlReplenType: "",
                ddlReview: "",
                ddlBu: val.replen_bu,
                fm1: val.fm1,
                fm2: val.fm2,
                fm3: val.fm3,
                fm4: val.fm4,
                fm5: val.fm5,
                fm6: 0,
                fm7: 0,
                fm8: 0,
                fm9: 0,
                fm10: 0,
                fm11: 0,
                fm12: 0,
                Package_Size: "",
                LblMaxCap: "",
                Service_Level: "",
                Safety_Stock: "",
                ddlRplCls: val.replen_type,
                ddlRplClsOld: this.state.oldValues[index].replen_type,
                ddlRplTyp: "",
                ddlRplTypOld: "",
                txtOOQ: "",
                txtMin: "",
                hdnMin: "",
                txtMax: "",
                hdnMax: "",
                hdnLocNo: val.loc_no,
                hdnItemNo: val.item_no,
                Replen_BU: val.replen_bu,
                ReplenOffReason: ""/*WW-798, changed and added values in BO, Divis Kumar R K*/
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            ReplenAction.UpdateItemAction(BO);
            isSubmit = false;
            this.setState({ selectedOption: "" })
        }


    }


    /**
     * RR_PC_22
     * */
    ZONChange = () => {
        if (this.state.ZeroOnHandCheck == true) {
            this.setState({ ZeroOnHandCheck: false })
        }
        else {
            this.setState({ ZeroOnHandCheck: true })
        }
    }

    ForecastClick = (e, value, index) => {

        Index = index;
        e.preventDefault();
        $('#forecastpopup').modal('show');
        this.setState({ selectedForecastIndex: index });
    }

    MoreDetailClick = (e, value, index) => {
        Index = index;
        e.preventDefault();
        $('#moredetailpopup').modal('show');
    }

    showReasonPopUp = () => { /*WW-798, used to display pop up, Divis Kumar R K*/
        canInsert = false;
        $('#reasonPopUp').modal('show');
    }

    insertReason = () => { /*WW-798, this block gets the reason, Divis Kumar R K*/
        if (this.state.selectedOption == "") {
            this.setState({ reasonError: false })
        }
        else {
            $('#reasonPopUp').modal('hide');
            isSubmit = true;
            canInsert = true;
            this.UpdateItemClick(this.state.customE, this.state.customVal, this.state.customIndex, "line_item");
            this.setState({ reasonError: true })
        }
    }

    hidePopUp = () => { /*WW-798, hides pop up, Divis Kumar R K*/
        $('#reasonPopUp').modal('hide');

        canInsert = true;
        this.setState({ selectedOption: "", reasonError: true })
    }

    closePopup = () => {


        this.setState({ HistoryCheck: false })
        $('#moredetailpopup').modal('hide');
        $('#bupopup').modal('hide');
        $('#historypopup').modal('hide');
        $('#forecastpopup').modal('hide');
    }

    bindReasons = () => {/*WW-798, bind reason in pop up, Divis Kumar R K*/
        
        return this.state.Reasons.map((reason, index) => {
            return (<option value={reason.DESCR50}>{reason.DESCR50}</option>)
        });
    }
    /**
     * RR_PC_21
     * */
    NotOnOrderChange = () => {
        if (this.state.NotOnOrderCheck == true) {
            this.setState({ NotOnOrderCheck: false })
        }
        else {
            this.setState({ NotOnOrderCheck: true })
        }
    }

    /**
     * RR_PC_24
     * */
    OnStatusChange = (event, val, index) => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let BO = {
            ddlSite: this.state.SelectSite,
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
            ItemNo: val.item_no,
            ActionStatus: event.target.value,
            OrderQTY: val.replen_qty,
            ddlBu: val.replen_bu,
            ddlSite: this.state.SelectSite,
        }

        ReplenAction.OnStatusChangeAction(BO)
        let GridData = [...this.state.GridData];
        GridData[index] = {
            ...GridData[index], [event.target.name]: event.target.value
        };
        this.setState({ GridData });
    }
    /**
     * RR_PC_25
     * */
    OnStatusChangeResponse = () => {
        let Response = JSON.parse(ReplenStore.StatusUpdate);
        console.log("Response", Response);
    }

    /**
    *For expand all button click
    * */
    expandAll = () => {


        if (this.state.isExpand == false) {
            this.setState({ isExpand: true });
            $('.header-arrow').removeClass('accordion-arrow-change');
            $('.content-row').addClass('d-none');
            $('.header-arrow').addClass('accordion-arrow-change');
            $('.content-row').removeClass('d-none');
        }
        else {
            this.setState({ isExpand: false });
            $('.header-arrow').addClass('accordion-arrow-change');
            $('.content-row').removeClass('d-none');
            $('.header-arrow').removeClass('accordion-arrow-change');
            $('.content-row').addClass('d-none');

        }
    }
    onAccordianClick = (event, Index) => {
        //$(event.currentTarget).children().toggleClass('accordion-arrow-change');
        //$(`#contentrow-${Index}`).toggleClass('d-none');
        //$('tr').removeClass('tr-border');
        //$(event.currentTarget).parent('tr').addClass('tr-border');
        //Bug 5360 - Nandhini L
        let classname = document.getElementById(`contentrow-${Index}`).className;
        this.state.GridData.forEach((_, idx) => {
            if (idx !== Index) {
                $(`#contentrow-${idx}`).addClass('d-none');
                $(`#arrow-${idx}`).removeClass('accordion-arrow-change');
            }
        });

        // Toggle the clicked accordion
        $(`#contentrow-${Index}`).toggleClass('d-none');
        $(`#arrow-${Index}`).toggleClass('accordion-arrow-change');
        if (classname.includes("d-none")) {
            $('.header-arrow').addClass('accordion-arrow-change');
            $('.content-row').removeClass('d-none');
            $('.header-arrow').removeClass('accordion-arrow-change');
            $('.content-row').addClass('d-none');
            $(event.currentTarget).children().toggleClass('accordion-arrow-change');
            $(`#contentrow-${Index}`).toggleClass('d-none');
            $('tr').removeClass('tr-border');
            $(event.currentTarget).parent('tr').addClass('tr-border');

        }
    }


    closeForecastPopup = () => {
        $('forecastpopup').modal('hide');
        this.setState({ GridData: this.state.BckGridData, selectedForecastIndex: null });

    }



    /**
     * RR_PC_09
     * */
    BindDataGrid = () => {


        if (this.state.GridData.length > 0) {
            return this.state.GridData.map((value, Index) => {
                let desc = value.description
                if (window.innerWidth < "1200") {
                    if (desc.length > 10) {
                        desc = desc.substring(0, 10) + "..."
                    }
                }

                let ImageUrl = "";
                if (this.state.ImgArr != "" && this.state.ImgArr != null) {
                    let ImageDet = this.state.ImgArr.filter((val, indexVal) => val.CUSTOMER_PART_NUMBER == value.item_no);
                    if (typeof (ImageDet) != undefined && ImageDet.length > 0) {
                        ImageUrl = ImageDet[0].ImageUrl;
                    }
                    else {
                        ImageUrl = `/Images/noimage_new.png`;
                    }

                }
                let ThumbnailImagefile = ImageUrl.split("|")

                if (ThumbnailImagefile[0]) {
                    value.Image = ThumbnailImagefile[0].replace('\\', '/');
                    if (value.Image.toLowerCase().indexOf("http") >= 0) {
                        ImageUrl = ThumbnailImagefile[0];
                    } else {
                        ImageUrl = ThumbnailImagefile[0].lastIndexOf(`/`) >= 0 ? ThumbnailImagefile[0].substring(ThumbnailImagefile[0].lastIndexOf("/") + 1, ThumbnailImagefile[0].length) : "noimage_new.png";
                        if (ImageUrl) {
                            ImageUrl = `/Images/${ImageUrl}`;
                        }
                    }
                } else {
                    ImageUrl = `/Images/noimage_new.png`;
                }
                if (ImageUrl.includes("NoImageAvailable")) {
                    ImageUrl = `/Images/noimage_new.png`;
                }

                return (
                    <tbody>
                        <tr>
                            <td className="accordion-toggle" onClick={(e) => this.onAccordianClick(e, Index)}>
                                <span className="accordion-arrow header-arrow" id={`arrow-${Index}`} />
                            </td>
                            <td className="d-md-table-cell">{value.item_no}</td>
                            <td className="d-md-table-cell">{desc}</td>
                            <td className="d-md-table-cell">{value.std_cost}</td>
                            <td className="d-md-table-cell ">{value.Extended_cost}</td>
                            <td className="d-md-table-cell"><input maxLength="9" type="text" value={value.replen_qty} name="replen_qty" onChange={(e) => this.handleGridChange(e, value, Index)} className="form-control float-left mr-2 " /></td>
                            <td className="d-md-table-cell">
                                <select className="form-control" value={value.replen_action} name="replen_action" onChange={(e) => this.OnStatusChange(e, value, Index)}>
                                    {/* <option value="0">Select </option>*/}
                                    <option value="1">Review</option>
                                    <option value="2">Approve</option>
                                    <option value="3">Cancel</option>
                                    <option value="4">Postpone Review 2 Weeks</option>
                                    <option value="5">Postpone Review 4 Weeks</option>
                                    <option value="6">Postpone Review 6 Weeks</option>
                                    <option value="7">Postpone Review 8 Weeks</option>
                                    <option value="8">Postpone Until Issue or Adjustment Occur</option>
                                    <option value="9">Autocrib</option>
                                </select>
                                <label className="catalog-label mt-2 mb-0 d-none" value={value.replen_action} id={`replen_action-${Index}`}>Replenish Type</label>

                            </td>
                        </tr>

                        <tr className="p d-none content-row" id={`contentrow-${Index}`}>

                            <td colSpan={7} className="hiddenRow border-bottom-0">
                                <div className="accordian-body py-1 px-3 border-bottom collapse show" id="order-row-1">
                                    <div className="px-3 py-3">
                                        <div className="row py-3">
                                            <div className="col-md-12">
                                                <h6 class="font-bold font-12 item-details-title">ITEM DETAILS</h6>
                                            </div>
                                            <div class="col-md-4 col-xl-2 text-center">
                                                {ImageUrl != "" ? <div className="col-md-12">
                                                    <img src={ImageUrl} alt="Image" className="mob-inv-Image-size" />
                                                </div> : <div className="col-md-12">
                                                        <img src="/Images/noimage_new.png" className="mob-inv-Image-size" alt="No_Image" style={{ "marginTop": "2rem" }} />
                                                    </div>}
                                            </div>
                                            <div class="col-md-8 col-xl-10">
                                                <div class="row">
                                                    <div class="col-md-6 col-xl-3 mb-4 mb-xl-0">
                                                        <table class="item-detail-inner-table text-nowrap">

                                                            <tbody>
                                                                <tr>
                                                                    <td className="border-0"><Trans>Replen BU</Trans><span> :</span></td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }}>{value.replen_bu != "" && value.replen_bu != undefined && value.replen_bu != null ? value.replen_bu : " - "}</td>
                                                                </tr>

                                                                <tr>
                                                                    <td className="border-0">Current On Hand:</td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }}>{(value.on_hand != "" && value.on_hand != undefined && value.on_hand != null) || value.on_hand == 0 ? value.on_hand : "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">Reserved Qty:</td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }}>{(value.rsq != "" && value.rsq != undefined && value.rsq != null) || value.rsq == 0 ? value.rsq : "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">Open PO Qty:</td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }}>{(value.open_po_qty != "" && value.open_po_qty != undefined && value.open_po_qty != null) || value.open_po_qty == 0 ? value.open_po_qty : "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">Open Req Qty:</td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }}>{(value.open_req_qty != "" && value.open_req_qty != undefined && value.open_req_qty != null) || value.open_req_qty == 0 ? value.open_req_qty : "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">Backorder:</td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }}>{(value.unshipped != "" && value.unshipped != undefined && value.unshipped != null) || value.unshipped == 0 ? value.unshipped : "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">Avg Days On Hand:</td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }}>{(value.avg_on_hand != "" && value.avg_on_hand != undefined && value.avg_on_hand != null) || value.avg_on_hand == 0 ? value.avg_on_hand : "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">Item History:</td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }}>
                                                                        <a href="#" className="anchor-btn" data-target="#historypopup" data-backdrop="static" data-keyboard="false" onClick={(e) => { this.HistoryClick(e, value, Index) }} >
                                                                            View History
                                                                        </a>

                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="col-md-6 col-xl-3 mb-4 mb-xl-0">
                                                        <table className="item-detail-inner-table text-nowrap">
                                                            <tbody>
                                                                <tr>
                                                                    <td className="border-0">Min:</td>
                                                                    <td className="p-0 border-0">
                                                                        <input
                                                                            maxLength="11" type="text" defaultValue={6}
                                                                            id="min-value"
                                                                            className="form-control w-75 h-50 py-1 fontregular" value={value.min} name="min" onChange={(e) => this.handleGridChange(e, value, Index)} />
                                                                        <label className="catalog-label mt-2 mb-0 d-none" value={value.min} id={`min-${Index}`}><Trans>Replenish Type</Trans></label>

                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">Max:</td>
                                                                    <td className="p-0 border-0">
                                                                        <input

                                                                            id="max-value"
                                                                            maxLength="11" type="text" defaultValue={7}
                                                                            className="form-control w-75 h-50 py-1 fontregular"
                                                                            value={value.max} name="max" onChange={(e) => this.handleGridChange(e, value, Index)} />
                                                                        <label className="catalog-label mt-2 mb-0 d-none" value={value.max} id={`max-${Index}`}><Trans>Replenish Type</Trans></label>

                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">Safety stock: </td>
                                                                    <td className="border-0" style={{ fontFamily: "'Roboto', sans-serif" }}>{(value.calc_ss != "" && value.calc_ss != undefined && value.calc_ss != null) || value.calc_ss == 0 ? value.calc_ss : "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">Suggested Min: </td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }}>{(value.sug_min != "" && value.sug_min != undefined && value.sug_min != null) || value.sug_min == 0 ? value.sug_min : "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">Suggested Max: </td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }}>{(value.sug_max != "" && value.sug_max != undefined && value.sug_max != null) || value.sug_max == 0 ? value.sug_max : "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">Package Size:</td>
                                                                    <td className="p-0 border-0 fontregular">
                                                                        <input
                                                                            maxLength="8" type="text" defaultValue={0}
                                                                            id="max-value"
                                                                            value={value.inc_orq} name="inc_orq"
                                                                            className="form-control w-75 h-50 py-1 fontregular"
                                                                            onChange={(e) => this.handleGridChange(e, value, Index)}

                                                                        />
                                                                        <label className="catalog-label mt-2 mb-0 d-none" value={value.inc_orq} id={`inc_orq-${Index}`}><Trans>Replenish Type</Trans></label>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">Lead Time:</td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }}>{(value.lead_time != "" && value.lead_time != undefined && value.lead_time != null) || value.lead_time == 0 ? value.lead_time : "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">Other BUs:</td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }}>
                                                                        <a href="#" className="anchor-btn" data-target="#bupopup" data-backdrop="static" data-keyboard="false" onClick={(e) => this.BUClick(e, value, Index)} >
                                                                            View BUs
                                                                        </a>

                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="col-md-6 col-xl-3">
                                                        <table className="item-detail-inner-table text-nowrap">
                                                            <tbody>
                                                                <tr>
                                                                    <td className="border-0">Date Added: </td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }}>{value.AddedDate != "" && value.AddedDate != undefined && value.AddedDate != null ? value.AddedDate : "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">Last Modified Date:</td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }}>{value.last_modified_dt != "" && value.last_modified_dt != undefined && value.last_modified_dt != null ? value.last_modified_dt : "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">Last Issued Date:</td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }}>{value.last_issue_dt != "" && value.last_issue_dt != undefined && value.last_issue_dt != null ? value.last_issue_dt : "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">Manufacture: </td>
                                                                    <td className="border-0" style={{ " fontFamily": "'RobotoRegular' !important" }}>{value.mfg != "" && value.mfg != undefined && value.mfg != null ? value.mfg : "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">Manf Part number:</td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }}>{value.mfg_part != "" && value.mfg_part != undefined && value.mfg_part != null ? value.mfg_part : "-"}</td>
                                                                </tr>
                                                                {/* Regression Bug- 5478 - K. Surya - Walmart_ Replenish Review_ UI issue in the accordion, the vendor's name overlaps the Action field UI */}
                                                                <tr>
                                                                    <td className="border-0">Vendor:</td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }} ><div className="display-long-word" title={value.char2} style={{ width: '120px' }}>

                                                                        {value.char2 != "" && value.char2 != undefined && value.char2 != null ? value.char2 : "-"}
                                                                    </div>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">Vendor Item ID: </td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }}>{value.sup_part_no != "" && value.sup_part_no != undefined && value.sup_part_no != null ? value.sup_part_no : "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">Forecast Info:</td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }}>
                                                                        <a href="#" className="anchor-btn" data-target="#forecastpopup" data-backdrop="static" data-keyboard="false" onClick={(e) => this.ForecastClick(e, value, Index)} >
                                                                            View Forecast
                                      </a>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="col-md-6 col-xl-3">
                                                        <table className="item-detail-inner-table text-nowrap">
                                                            <tbody>
                                                                <tr>
                                                                    <td className="border-0">Replen Class:</td>
                                                                    <td className="p-0 border-0">
                                                                        <select
                                                                            className="form-control rounded h-50 py-1 fontregular"
                                                                            name="replen_type" value={value.replen_type} onChange={(e) => this.handleGridChange(e, value, Index)}
                                                                            id="vendor-1"

                                                                        >
                                                                            <option value="MANL">Manual Review</option>
                                                                            <option value="AUTO">Automatic</option>
                                                                            <option value="X">Replen Off</option>
                                                                        </select>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">Inventory Type:</td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }}>{value.inventory_type != "" && value.inventory_type != undefined && value.inventory_type != null ? value.inventory_type : "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">Unit of Measure:</td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }}>{value.UOM != "" && value.UOM != undefined && value.UOM != null ? value.UOM : "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">Item Stock Type:</td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }}>{value.ItemStock != "" && value.ItemStock != undefined && value.ItemStock != null ? value.ItemStock : "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">Forecast Family: </td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }}>{value.Forecast_Family != "" && value.Forecast_Family != undefined && value.Forecast_Family != null && value.Forecast_Family != " " ? value.Forecast_Family : "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">Action:</td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }}>{value.action_code != "" && value.action_code != undefined && value.action_code != null ? value.action_code : "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">Default Putaway:&nbsp;</td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }}>{value.DefaultPutaway != "" && value.DefaultPutaway != undefined && value.DefaultPutaway != null && value.DefaultPutaway != " " ? value.DefaultPutaway : "-"}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="border-0">More Details:&nbsp;</td>
                                                                    <td className="border-0" style={{ "fontFamily": "'RobotoRegular' !important" }}>
                                                                        <a href="#" data-target="#moredetailpopup" data-backdrop="static" data-keyboard="false">
                                                                            <img
                                                                                className="anchor-btn"
                                                                                src="images/history.png"
                                                                                alt="details-icon"
                                                                                onClick={(e) => this.MoreDetailClick(e, value, Index)}
                                                                            />
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="col-md-12 text-center mb-3">
                                                        <button className="btn btn-primary custom-btn-primary primary-btn mr-3" style={{ 'marginTop': '2.5em' }} onClick={(e) => this.UpdateItemClick(e, value, Index, "line_item")}><Trans>Update Item</Trans></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>

                    </tbody>
                );
            });


        }
    }

    render() {
        return (
            <>
                <div className="container-fluid content-section content-margin custom-mb">
                    <div className="row">
                        <div id="accordion" className="col-lg-12 float-left p-0">
                            <div className="col-lg-12 float-left border-bottom">
                                <div className="col-md-12 page-heading mb-3 Ord-title">
                                    <a data-toggle="collapse" href="#collapseOne" className="accordion-toggle float-left mobileacc-arrow">
                                        <span className="accordion-arrow accordion-arrow-change" /></a>
                                    <h5 className="page-title"><Trans>Replenish Review</Trans></h5>
                                    <div className="fav-item-maintenance-icon mt-1">
                                        <input type="checkbox" id="checkbox-OrdStatus" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                        <label htmlFor="checkbox-OrdStatus">
                                            <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                                <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                                    <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                                    <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                                    <g className="grp7" opacity={0} transform="translate(7 6)">
                                                        <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                        <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp6" opacity={0} transform="translate(0 28)">
                                                        <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                        <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp3" opacity={0} transform="translate(52 28)">
                                                        <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                        <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp2" opacity={0} transform="translate(44 6)">
                                                        <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                        <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp5" opacity={0} transform="translate(14 50)">
                                                        <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                        <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp4" opacity={0} transform="translate(35 50)">
                                                        <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                        <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp1" opacity={0} transform="translate(24)">
                                                        <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                        <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                                    </g>
                                                </g>
                                            </svg>
                                        </label>
                                    </div>
                                    {/*}
                                    <div className="fav-item-maintenance-icon mt-1">
                                        <input type="checkbox" id="checkbox-1" className="checknow" />
                                        <label htmlFor="checkbox-1">
                                            <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                                <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                                    <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                                    <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                                    <g className="grp7" opacity={0} transform="translate(7 6)">
                                                        <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                        <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp6" opacity={0} transform="translate(0 28)">
                                                        <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                        <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp3" opacity={0} transform="translate(52 28)">
                                                        <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                        <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp2" opacity={0} transform="translate(44 6)">
                                                        <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                        <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp5" opacity={0} transform="translate(14 50)">
                                                        <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                        <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp4" opacity={0} transform="translate(35 50)">
                                                        <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                        <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp1" opacity={0} transform="translate(24)">
                                                        <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                        <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                                    </g>
                                                </g>
                                            </svg>
                                        </label>
                                    </div>
                                    */}
                                </div>
                            </div>
                            <div id="collapseOne" className="card-body collapse show" data-parent="#accordion">
                                <div className="col-md-12 border-bottom pb-3">
                                    <div className="row align-items-center">
                                        <div className="col-md-3 mb-4">
                                            {/* Regression bug - 5479 - K. Surya - Walmart_ Replenish Review_ Not able to select the "select "value in the select a site field after selecting any site from the field.*/}
                                            <label className="form-label catalog-label" for="site-dpd"><Trans>Select a site</Trans><span class="color-validation">*</span></label>
                                            <select className="form-control" id="site-dpd" name="SelectSite" value={this.state.SelectSite} onChange={this.handleSiteChange}>
                                                <option value="">Select</option>
                                                {this.Bindsite()}
                                            </select>
                                        </div>
                                        <div className="col-md-3 mb-4">
                                            <label className="form-label catalog-label" for="itemID"><Trans>Item</Trans><span> </span><Trans>ID</Trans></label>

                                            <input type="text" id="itemID" maxLength="9" className="form-control" name="txtItemID" value={this.state.txtItemID} onChange={this.handleChange} />
                                            <span className={this.state.txtItemID != null && this.state.txtItemID != "" && this.state.txtItemID != " " ? "search-cancel-header cursor-pointer" : "d-none"} style={{ "float": "left", "marginRight": '0px', "marginTop": '37px' }} onClick={() => this.clearItemId()}></span>

                                        </div>

                                        <div className="col-md-3 mb-4">
                                            <label className="form-label catalog-label" for="action-code"><Trans>Action Code</Trans></label>
                                            <select className="form-control" id="action-code" name="SelectActionCode" value={this.state.SelectActionCode} onChange={this.handleChange}>
                                                <option value="">Select</option>
                                                <option value="1">Backorder</option>
                                                <option value="2">Below Demand</option>
                                                <option value="3">Using Safety Stock</option>
                                                <option value="0">Balanced</option>
                                                <option value="6">Overstocked</option>
                                                <option value="5">Overstock With Open PO</option>
                                                <option value="4">Surplus Exceeded 1 yr</option>
                                            </select>
                                        </div>
                                        <div className="col-md-3 mb-4">
                                            <label className="form-label catalog-label" for="utilization-code"><Trans>Utilization_Code</Trans></label>
                                            <select className="form-control" id="utilization-code" name="SelectUtilCode" value={this.state.SelectUtilCode} onChange={this.handleChange}>
                                                <option value="">Select</option>
                                                <option value="A">A</option>
                                                <option value="B">B</option>
                                                <option value="C">C</option>
                                                <option value="D">D</option>
                                                <option value="CS">CS</option>

                                            </select>
                                        </div>


                                        {/****WW-219**/}
                                        <div className="col-md-3 mb-4">
                                            <label className="form-label catalog-label" for="inventory-type"><Trans>Inventory</Trans><span> </span><Trans>type</Trans></label>
                                            <select className="form-control" id="inventory-type" name="SelectInventoryType" value={this.state.SelectInventoryType} onChange={this.handleChange}>
                                                <option value="">Select</option>
                                                <option value="GM">GM</option>
                                                <option value="HVAC">HVAC</option>
                                                <option value="Repair">Repair</option>
                                            </select>
                                        </div>
                                        {/********END*********/}


                                        <div className="col-md-3 mb-4">
                                            <label className="form-label catalog-label" for="replenish-status"><Trans>Replenish Status</Trans></label>
                                            <select className="form-control" id="replenish_status" name="SelectReplenStatus" value={this.state.SelectReplenStatus} onChange={this.handleChange}>
                                                <option value="">Select </option>
                                                <option value="1">Review</option>
                                                <option value="2">Approve</option>
                                                <option value="3">Cancel</option>
                                                <option value="4">Postpone Review 2 Weeks</option>
                                                <option value="5">Postpone Review 4 Weeks</option>
                                                <option value="6">Postpone Review 6 Weeks</option>
                                                <option value="7">Postpone Review 8 Weeks</option>
                                                <option value="8">Postpone Until Issue or Adjustment Occur</option>
                                                <option value="9">Autocrib</option>
                                            </select>
                                        </div>
                                        <div className="col-md-3 mb-4">
                                            <label className="form-label catalog-label d-block" for="replenish-status">Quantity on hand</label>
                                            <div className="d-flex flex-row w-100">
                                                <div className="form-check mt-2 mr-4 ">
                                                    <input type="checkbox" className="form-check-input" id="defaultCheck1" checked={this.state.NotOnOrderCheck} name="NotOnOrderCheck" onChange={e => this.NotOnOrderChange()} />
                                                    <label className="form-check-label font-13 color-grey text-nowrap" htmlFor="defaultCheck1"><Trans>Not On Order</Trans></label>
                                                </div>
                                                <div className="form-check mt-2 mr-4">
                                                    <input type="checkbox" className="form-check-input" id="defaultCheck2" checked={this.state.ZeroOnHandCheck} name="ZeroOnHandCheck" onChange={e => this.ZONChange()} />
                                                    <label className="form-check-label font-13 color-grey text-nowrap" value htmlFor="defaultCheck2"><Trans>Zero On Hand</Trans></label>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-md-12 mb-4">{/*Forecast modal Starts here*/}
                                        <div className="d-flex justify-content-end">
                                            <button type="button" className="btn btn-dark-grey font-14 font-medium mr-3 px-4" onClick={e => this.CancelClick()}><Trans>Clear</Trans></button>
                                            <button type="button" className="btn btn-custom-primary font-14 font-medium mr-3 px-4" onClick={e => this.GetDataClick("1", true, "All", "ALL ")}><Trans>Get Data</Trans></button>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                        {this.state.GridData.length > 0 ?
                            <div className="col-md-12 mt-4 pb-3">

                                <div className="d-flex justify-content-between mb-4 align-items-center">
                                    <h5 className="font-bold font-16 text-black m-0">Item Details</h5>
                                    <div className="d-md-flex text-nowrap">
                                        <div className="d-flex">
                                            <div className="input-group dropdown-search mr-2 w-100">
                                                <div className="input-group-prepend">
                                                    <button className="btn btn-outline-secondary dropdown-toggle font-14 shadow-none" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><Trans>{this.state.filterDisplayName}</Trans></button>
                                                    <div className="dropdown-menu z-1035">
                                                        <a className="dropdown-item" href="" onClick={(e) => this.filterClick(e, "All", "ALL")}><Trans>All</Trans></a>
                                                        <a className="dropdown-item" href="" onClick={(e) => this.filterClick(e, "Item ID", "item_no")}><Trans>Item ID</Trans></a>
                                                        <a className="dropdown-item" href="" onClick={(e) => this.filterClick(e, "Description", "description")}><Trans>Description</Trans></a>
                                                    </div>
                                                </div>
                                                <input type="text" className="form-control" style={{ paddingRight: "55px" }} id="searchTxt" maxlength="254" value={this.state.searchTxt} placeholder="Search" aria-label="Text input with dropdown button" onKeyDown={this.keyPress} onChange={(e) => this.handleSearchTxt(e)} />
                                                <span className={this.state.searchTxt != null && this.state.searchTxt != undefined && this.state.searchTxt != "" ? "search-cancel-header cursor-pointer" : "d-none"} style={{ "float": "left" }} onClick={() => this.ClearSearch()}></span>
                                                <span className="dropdown-search-icon" id="searchIcon" onClick={() => this.handleSearch()} />
                                            </div>

                                            <div className="info-container">
                                                <button type="button" className=" btn btn-custom-primary font-14 font-medium px-4 mr-2" data-toggle="tooltip" data-placement="top" onClick={this.ProcessReplenClick}><Trans>Process Replen</Trans></button>
                                                <span className="grid-info-icon" style={{ minWidth: "120px" }} >Replen can be processed only if the order qty is greater than zero and action as Approve also the line must have been updated before processing replen</span>
                                            </div>
                                            <div className="d-flex">

                                                <button type="button" className="btn btn-custom-primary font-14 font-medium px-4 mr-2" onClick={this.expandAll} >{!this.state.isExpand ? `Expand All` : `Collapse All`}</button>
                                                <button className="btn btn-custom-primary font-14 font-medium px-4" onClick={this.ExportToExcelClick}><Trans>Export to Excel</Trans></button></div>
                                        </div>



                                    </div>
                                </div>


                                <div className="table-responsive mt-2">
                                    <table className="table ZEUS_Grid FOM-grid mobileresponsive-grid font-14">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th className="position-sort-icon">Item ID<span className="sort-up ml-1" onClick={(e) => this.sortingClick("item_no", "ASC")}><img src="Images/sort2.svg" alt="sort-up" /></span><span className="sort-down ml-1" onClick={(e) => this.sortingClick("item_no", "DESC")}><img src="Images/sort1.svg" alt="sort-down" /></span></th>
                                                <th className="position-sort-icon">Description<span className="sort-up ml-1" onClick={(e) => this.sortingClick("description", "ASC")}><img src="Images/sort2.svg" alt="sort-up" /></span><span className="sort-down ml-1" onClick={(e) => this.sortingClick("description", "DESC")}><img src="Images/sort1.svg" alt="sort-down" /></span></th>
                                                <th className="text-right">Cost $</th>
                                                <th className="text-right">Extended Cost $</th>
                                                <th>Order Quantity</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        {this.BindDataGrid()}
                                    </table>
                                </div></div> : null}

                        <div className="col-md-12">
                            {this.state.GridData.length > 0 ? <>
                                <div className="col-md-12">
                                    <span className="total-records mt-2 d-inline-block">
                                        <Trans>Number of Records</Trans><span> :</span><span className="ml-2">{this.state.totalCount}</span>
                                    </span>
                                    {this.state.totalCount > 10 ?
                                        <ReactPaginate
                                            previousLabel={<span className="right-pagination-arrow" />}
                                            nextLabel={<span className="left-pagination-arrow" />}
                                            previousClassName={'page-item'}
                                            nextClassName={'page-item'}
                                            previousLinkClassName={'page-link'}
                                            nextLinkClassName={'page-link'}
                                            disabledClassName={'disabled'}
                                            breakLabel={'...'}
                                            breakClassName={'page-item'}
                                            breakLinkClassName={'page-link'}
                                            pageCount={this.state.pageCount}
                                            marginPagesDisplayed={1}
                                            pageRangeDisplayed={2}
                                            onPageChange={this.handlePageClick}
                                            containerClassName={'custom-pagination pagination float-right'}
                                            pageClassName={'page-item'}
                                            pageLinkClassName={'page-link'}
                                            activeClassName={'active'}
                                            hrefBuilder={() => '#'}
                                            forcePage={this.state.PageNo - 1}
                                        /> : null}
                                </div></> : null}




                        </div>  </div>




                    {/*Forecast modal Starts here*/}

                    <div className="modal fade forecast-details-modal p-0" id="forecastpopup"
                        tabIndex={-1}
                        role="dialog"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog modal-xl" role="document">
                            <div className="more-detail-modal-content border-0" style={{ marginTop: "120px" }} onClick={(e) => e.stopPropagation()}>
                                <div className="modal-header sp-delv-header align-items-center px-4">
                                    <h5 className="modal-title" id="exampleModalLongTitle">
                                        Forecast Details
        </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <img src="images/close-icon.svg" alt="close" onClick={() => this.closeForecastPopup(Index)} />
                                    </button>
                                </div>
                                {this.bindForecast(Index)}

                                {/*button*/}
                                {/*<div className="modal-footer border-0 px-4">
                                        <button className="btn btn-dark-grey font-14 font-medium mr-3 px-4"
                                            type="button"
                                            data-dismiss="modal">  Cancel </button>

                                        <button
                                            className="btn btn-custom-primary font-14 font-medium px-4" onClick={(e) => this.UpdateItemClick(e, value, Index)}
                                            type="button">Save</button>


                                    </div>*/}
                                {/*button*/}
                            </div>
                        </div>
                    </div>

                    {/*Forecast Modal Ends here*/}

                    {/*BU Modal Starts here*/}

                    <div
                        className="modal fade forecast-details-modal p-0" id="bupopup"
                        tabIndex={-1}
                        role="dialog"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog modal-xl" role="document">
                            <div className="modal-bu border-0" style={{ marginTop: "120px" }}>
                                <div className="modal-header sp-delv-header align-items-center px-4">
                                    <h5 className="modal-title" id="exampleModalLongTitle">
                                        BUs details
          </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <img src="images/close-icon.svg" alt="close" onClick={() => this.closePopup()} />
                                    </button>
                                </div>
                                {/*Body Starts here*/}
                                <div className="modal-body px-4">
                                    {/*grid starts here*/}
                                    <div className="table-responsive popup-grid-scroll-style">
                                        <table className="table split-delv-table mb-0">
                                            <thead className="sticky-top">
                                                <tr className="border-bottom">
                                                    <th>Replen BU</th>
                                                    <th>BU description</th>
                                                    <th>Qty available</th>
                                                    <th>Min</th>
                                                    <th>Max</th>
                                                    <th>Replen class</th>
                                                    <th>Replen off</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.bindBuGrid()}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="modal-footer border-0 justify-content-center">
                                    <button
                                        className="btn btn-custom-primary font-14 font-medium px-4"
                                        type="button"
                                        data-dismiss="modal"
                                    >
                                        OK
          </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* BU Modal Ends here*/}


                    {/* More details Modal Starts here*/}
                    <div
                        className="modal fade more-details-popup p-0" id="moredetailpopup"
                        tabIndex={-1}
                        role="dialog"
                        aria-hidden="true"
                    >
                        <div className="modal-dialog more-details-width" role="document">
                            <div className="more-detail-modal-content border-0">
                                <div className="modal-header sp-delv-header align-items-center px-4">
                                    <h5 className="modal-title" id="exampleModalLongTitle">
                                        More details
          </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <img src="images/close-icon.svg" alt="close" onClick={() => this.closePopup()} />
                                    </button>

                                </div>

                                {this.bindMoreDetail(Index)}




                            </div>
                        </div>
                    </div>

                    {/* More detail Modal Ends here*/}


                    {/*Modal Starts here*/}
                    <div className="modal" id="reasonPopUp" data-backdrop="static" data-keyboard="false">
                        <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                            <div className="modal-content-1">
                                {/* Modal Header */}
                                <div className="modal-header">
                                    <h4 className="modal-title mt-1"><Trans>Reason for choosing replenishment off</Trans></h4>
                                    <button type="button" className="btn close-btn" onClick={() => this.hidePopUp()}>
                                        X
              </button>
                                </div>
                                {/* Modal body */}
                                <div className="modal-body" >
                                    <div className="row">
                                        <div className="col-md-12 float-left">
                                            <div className="col-md-12 col-lg-12 mb-3 float-left p-0">
                                                <label className="float-left"><Trans>Reason</Trans></label>

                                                <select className="form-control float-left" value={this.state.selectedOption} onChange={(e) => { this.setState({ selectedOption: e.target.value }) }}>
                                                    <option value="">Select an option</option>
                                                    {this.bindReasons()}
                                                </select>


                                            </div>
                                            <div className="center"><span className="error_message" hidden={this.state.reasonError}>Please select an option to submit the reason</span></div>
                                        </div>

                                    </div>
                                    <div className="col-md-12 text-center mb-2 mt-2">
                                        <button className="btn btn-primary custom-btn-primary primary-btn px-4 mt-3" onClick={() => this.insertReason()}><Trans>Submit</Trans></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*Modal Ends here*/}

                    {/*History Modal Starts here*/}
                    <div
                        className="modal fade forecast-details-modal p-0" id="historypopup"
                        tabIndex={-1}
                        role="dialog"
                        ari=""
                        overflow-autoa-hidden="true"
                    >
                        <div className="modal-dialog modal-xl" role="document">
                            <div className="modal-content-1 border-0" style={{ marginTop: "125px" }}>
                                <div className="modal-header sp-delv-header align-items-center">
                                    <h5 className="modal-title" id="exampleModalLongTitle">
                                        History Details
          </h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-dismiss="modal"
                                        aria-label="Close"

                                    >
                                        <img src="images/close-icon.svg" alt="close" onClick={() => this.closePopup()} />
                                    </button>
                                </div>
                                {/*Body Starts here*/}
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-md-12 mt-1">
                                            <div className="border-bottom">
                                                <ul
                                                    className="nav nav-pills border-0 flex-nowrap overflow-auto"
                                                    id="myTab"
                                                    role="tablist"
                                                >

                                                    <li className="nav-item ml-0 mr-4 mb-1">
                                                        <a
                                                            className={`nav-link rounded-0 bg-white ml-0 font-medium custom-color.active  selected-tab.active:after custom-color  position-relative px-0 ${!this.state.HistoryCheck ? 'selected-tab active' : ""}`}
                                                            id="item-history-details"
                                                            data-toggle="tab"
                                                            href="#item-history"
                                                            role="tab"
                                                            aria-selected="true"
                                                            onClick={() => this.bindHistoryGrid("ItemDetails")}



                                                        >
                                                            Item history details
                    </a>
                                                    </li>

                                                    <li className="nav-item ml-1">
                                                        <a
                                                            className={`nav-link rounded-0 bg-white custom-color.active  selected-tab.active:after font-medium custom-color selected-tab ml-0 position-relative px-0 ${this.state.HistoryCheck ? 'selected-tab active' : ""}`}
                                                            id="vendor-history-details"
                                                            data-toggle="tab"
                                                            href="#vendor-history"
                                                            role="tab"
                                                            aria-selected="false"

                                                            onClick={() => this.bindHistoryGrid("VendorDetails")}

                                                        >
                                                            Vendor history details
                    </a>
                                                    </li>
                                                </ul>
                                            </div>
                                            {this.state.HistoryCheck == false ?
                                                <div
                                                    className="tab-content Catalog-Items w-100"
                                                    id="myTabContent"
                                                >
                                                    {/*Shipping label starts here*/}
                                                    <div
                                                        className="tab-pane py-4 px-0 fade active show"
                                                        id="item-history"
                                                        role="tabpanel"
                                                    >
                                                        {/*grid starts here*/}
                                                        <div className="table-responsive popup-grid-scroll-style">
                                                            <table className="table split-delv-table mb-0">
                                                                <thead className="sticky-top">
                                                                    <tr className="border-bottom">
                                                                        <th>Last modified date</th>
                                                                        <th>Min</th>
                                                                        <th>Max</th>
                                                                        <th>Replen type</th>
                                                                        <th>Replen class</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {this.bindHistoryGrid("ItemDetails")}

                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                : null}

                                            {/*grid ends here*/}

                                            {/*Shipping label ends here*/}
                                            {/*Web Source starts here*/}
                                            {this.state.HistoryCheck == true ?
                                                <div
                                                    className="tab-pane py-4 px-0"
                                                    id="vendor-history"
                                                    role="tabpanel"
                                                >
                                                    {/*grid starts here*/}
                                                    <div className="table-responsive popup-grid-scroll-style">
                                                        <table className="table split-delv-table mb-0">
                                                            <thead className="sticky-top">
                                                                <tr className="border-bottom">
                                                                    <th>Vendor name</th>
                                                                    <th>Date added</th>
                                                                    <th>Price</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {this.bindHistoryGrid("VendorDetails")}

                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                : null}
                                            {/*grid ends here*/}
                                            {/*  </div>
                                                {/*Web Source ends here*/}
                                            {/*     </div>
                                        </div>
                                    </div>
                                </div>
                                {/*Body ends here*/}
                                            {/*button*/}
                                            <div className="modal-footer border-0 justify-content-center">
                                                <button
                                                    className="btn btn-custom-primary font-14 font-medium px-4"
                                                    type="button"
                                                    data-dismiss="modal"
                                                    onClick={() => this.closePopup()}
                                                >
                                                    OK
          </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>











                </div></>

        );

    }
}

export default withTranslation()(ReplenishReview);
